// Parser SSE stream từ gateway/infer.
//
// Sử dụng fetch Response.body (ReadableStream<Uint8Array>) → AsyncIterable<StreamEvent>.

import type { StreamEvent } from "./types";

export async function* parseSseStream(
  body: ReadableStream<Uint8Array>,
): AsyncGenerator<StreamEvent, void, unknown> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });

      let idx: number;
      while ((idx = buffer.indexOf("\n\n")) >= 0) {
        const block = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);
        const ev = parseBlock(block);
        if (ev) yield ev;
      }
    }
    if (buffer.trim()) {
      const ev = parseBlock(buffer);
      if (ev) yield ev;
    }
  } finally {
    try {
      reader.releaseLock();
    } catch {
      /* ignore */
    }
  }
}

function parseBlock(block: string): StreamEvent | null {
  let event = "";
  let dataLines: string[] = [];
  for (const line of block.split("\n")) {
    if (line.startsWith("event: ")) event = line.slice("event: ".length).trim();
    else if (line.startsWith("data: ")) dataLines.push(line.slice("data: ".length));
  }
  if (!event) return null;
  const data = dataLines.join("\n");
  let json: Record<string, unknown>;
  try {
    json = JSON.parse(data);
  } catch {
    return null;
  }
  switch (event) {
    case "delta":
      return { type: "delta", content: String(json.content ?? "") };
    case "tool_calls":
      return { type: "tool_calls", tool_calls: (json.tool_calls as StreamEvent extends { tool_calls: infer T } ? T : never) ?? [] };
    case "usage":
      return {
        type: "usage",
        prompt_tokens: Number(json.prompt_tokens ?? 0),
        completion_tokens: Number(json.completion_tokens ?? 0),
      };
    case "done":
      return { type: "done", finish_reason: (json.finish_reason as StreamEvent extends { finish_reason: infer T } ? T : never) ?? "stop" };
    case "error":
      return {
        type: "error",
        code: String(json.code ?? "error"),
        message: String(json.message ?? "unknown error"),
      };
    default:
      return null;
  }
}
